import React, { useEffect, useRef, useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons'

import Button from 'design-system/button'
import { ButtonSizes, ButtonVariant } from 'design-system/button/src/Button'
import { ButtonSettings } from '../ButtonSettings'
import EmailForm from '../EmailForm'
import styles from './SendEmails.module.scss'

interface Values {
  emailSubject: string
  emailBody: string
}

interface IProps {
  defaultValues?: Values | null
  canEdit?: boolean
  onSave: (values: Values) => void
  isNewCourse?: boolean
  courseName?: any
}
const SendEmail: React.FC<IProps> = ({ defaultValues, canEdit, onSave }) => {
  const { t } = useTranslation()

  const [showModal, setShowModal] = useState(false)

  const touched = useRef(false)

  const [subject, setSubject] = useState(defaultValues?.emailSubject || '')
  const [content, setContent] = useState(defaultValues?.emailBody || '')

  useEffect(() => {
    if (defaultValues && !touched.current) {
      setContent(defaultValues.emailBody)
      setSubject(defaultValues.emailSubject)
    }
  }, [defaultValues, setContent, setSubject, touched])

  const handleClose = () => {
    setShowModal(false)
  }

  const handleSaveFormat = () => {
    onSave({
      emailSubject: subject,
      emailBody: content,
    })
    setShowModal(false)
  }

  return (
    <>
      <ButtonSettings
        onClick={() => setShowModal(!showModal)}
        disabled={!canEdit}
      />
      <Modal
        size="lg"
        show={showModal}
        onHide={handleClose}
        centered
        enforceFocus={false}
      >
        <Modal.Header
          closeButton
          className="ml-3 mr-3 mt-2 pb-2"
          translate={'yes'}
        >
          <Modal.Title>
            <p className={styles.headFont}>
              {t('administration.monitor.sendEmail.title')}
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="ml-3 mr-3">
          <Form>
            <EmailForm
              emailBody={content}
              setSubject={(newValue) => {
                touched.current = true
                setSubject(newValue)
              }}
              emailSubject={subject}
              setEmailBody={(newValue) => {
                touched.current = true
                setContent(newValue)
              }}
            />
            <div className={styles.countLabel}>
              {t(
                'administration.courses.new.form.invitationNotification.sendEmailModal.notice'
              )}
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer className="ml-3 mr-3 mt-2">
          <Button
            variant={ButtonVariant.Secondary}
            size={ButtonSizes.Small}
            onClick={handleClose}
          >
            {t('commons.buttons.cancel')}
          </Button>
          <Button
            variant={ButtonVariant.Primary}
            size={ButtonSizes.Small}
            onClick={handleSaveFormat}
            disabled={!subject.length || !content.length}
          >
            <FontAwesomeIcon className="mr-2" icon={faPaperPlane} />
            {t(
              'administration.courses.new.form.invitationNotification.sendEmailModal.schedule'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default SendEmail
